import React, { Fragment, useEffect, useState } from "react";

import ReplayPreview from "../components/ReplayPreview";
import VisibilitySensor from "react-visibility-sensor";
import { useTranslation } from "react-i18next";

function LastReplaysSensor({
  replayId,
  page = 0,
  onDataUpdated = () => {},
  infinite = true,
  onClicked = () => {}
}) {
  const [fetching, setFetching] = useState(false);
  const [visible, setVisible] = useState(false);
  const [replays, setReplays] = useState([]);

  const { t } = useTranslation();

  const onChange = (evt) => {
    if (replayId !== null && evt && !visible) {
      setFetching(true);
      setVisible(true);
      let url =
        window.serverUrl+"/social/related.php?id=" +
        replayId +
        "&page=" +
        page;
      fetch(url)
        .then((r) => r.json())
        .then((_data) => {
          setReplays(_data);
          onDataUpdated();
          setFetching(false);
        })
        .catch((err) => {
          console.error("fetch problem", err);
          setFetching(false);
          setVisible(true);
        });
    }
  };

  useEffect(() => {
    return () => {};
  }, []);

  return (
    <>
      {replays.map((hand, index) => {
        return infinite || index < 6 ? (
          <ReplayPreview
            key={hand.replayId + "-" + index}
            hand={hand}
            onClicked={onClicked}
          ></ReplayPreview>
        ) : (
          <Fragment key={hand.replayId + "-" + index}></Fragment>
        );
      })}
      {!visible && !fetching ? (
        <VisibilitySensor onChange={onChange}>
          <div className="sensor">{t("loading")}...</div>
        </VisibilitySensor>
      ) : !fetching && replays.length === 10 && infinite ? (
        <LastReplaysSensor
          replayId={replayId}
          page={page + 1}
          onDataUpdated={onDataUpdated}
          onClicked={onClicked}
        ></LastReplaysSensor>
      ) : (
        <></>
      )}
    </>
  );
}
export default LastReplaysSensor;
